import { createGlobalStyle } from 'styled-components';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './windowInfo.css';
import 'react-datepicker/dist/react-datepicker.css';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html,
  body,
  #root {
    height: 100%;
    text-rendering: optimizelegibility;
  }

  html {
    font-size: 62.5%;
  }

  body {
    -webkit-font-smoothig: antialiased;
    font-size: 1.6rem;
    background-color: #f2f2f2;
  }

  body,
  input,
  button {
    font: 14px 'Poppins', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  .MuiFormHelperText-root {
    margin: -0.8rem 0 1rem .5rem;
  }

  .MuiSelect-select {
    padding-top: 10.5px;
    padding-bottom: 10.5px
  }

  .field-select > label[data-shrink='false'] {
    margin-left: 1rem !important;
    margin-top: -1rem !important;
  }

  .field-select > label[data-shrink='true'] {
    margin-top: -.6rem !important;
    margin-left: .9rem !important;
    background: #fff;
    z-index: 1;
    padding: 0 .8rem;
  }

  .MuiFormHelperText-root.Mui-error {
    margin-top: -1rem;
    margin-bottom: 1rem;
  }
`;
